import { Avatar, Box, Typography } from '@mui/joy';
import { useMemo } from 'react';
import { useAuth } from 'react-oidc-context';

interface AccountInfoProps {
  showDetailedRole?: boolean;
  selectedRole?: {
    department: string;
    role: string;
    jobRole?: string;
  };
  profilePicture?: string;
}

export const AccountInfo = ({
  showDetailedRole = false,
  selectedRole,
  profilePicture,
}: AccountInfoProps) => {
  const auth = useAuth();
  const { profile } = auth.user ?? {};
  const groups = profile && (profile['cognito:groups'] as string[]);

  const fallbackRole = useMemo(() => {
    if (groups?.includes('Admin')) return 'Admin';
    if (groups?.length) return groups[0];
    return undefined;
  }, [groups]);

  const displayRole =
    showDetailedRole && selectedRole
      ? `${selectedRole.department ? selectedRole.department : ''}${selectedRole.department ? ' ' : ''}(${selectedRole.role})`
      : fallbackRole;

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', p: 0, px: 0 }}>
      <Avatar
        variant="outlined"
        size="sm"
        sx={{ '--Avatar-size': '24px' }}
        src={profilePicture}
      />
      <Box sx={{ minWidth: 0, flex: 1 }}>
        {displayRole && (
          <Typography
            level="title-sm"
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '180px',
            }}
          >
            {displayRole}
          </Typography>
        )}
        {showDetailedRole && selectedRole?.jobRole && (
          <Typography
            level="body-xs"
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '180px',
              color: 'text.tertiary',
              fontStyle: 'italic',
            }}
          >
            {selectedRole.jobRole}
          </Typography>
        )}
        <Typography
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          level="body-xs"
        >
          <Typography level="body-sm" sx={{ fontWeight: 500 }}>
            {profile?.email}
          </Typography>
        </Typography>
      </Box>
    </Box>
  );
};
